function filterDiscounts(item) {
  return item.item_type !== 'discount';
}
function filterMailboxDiscount(item) {
  return !(item.item_type === 'fees' && item.product_type === 'mailboxv2');
}
function filterOutSimpleHostingDiscountAndFreeDomain(item) {
  return !(item.product_type === 'paas' && item.action_name === 'create' && !item.details?.product_uuid);
}
function filterOutSimpleHostingRelease(item) {
  return !(item.product_type === 'paas' && item.action_name === 'release');
}
function filterOutBaseKitDelete(item) {
  return !(item.product_type === 'sites' && item.action_name === 'delete');
}
export function filterDiscarded(item) {
  return filterDiscounts(item) && filterMailboxDiscount(item) && filterOutSimpleHostingDiscountAndFreeDomain(item) && filterOutSimpleHostingRelease(item) && filterOutBaseKitDelete(item);
}